<template>
  <div   class="page-index">
    <div>
      <div class="list-block media-list">
        <ul>
          <li v-for="pro in merchList">
            <label class="label-checkbox item-content">
              <input type="checkbox" name="my-checkbox" >
              <div class="item-media"><i class="icon icon-form-checkbox"></i></div>
              <div class="item-inner" style="padding-bottom: 0rem">
                <div class="item-title-row">
                  <div class="item-title"><span v-for="title in pro._titleList" style="margin-right: .3rem"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span></span></div>
                  <div class="item-after" style="font-size: xx-small">
                    <label class="label-checkbox checkbox-el " v-for="abstract in pro._abstractList">
                      <div class="item-media small-checkbox small-filter-el"><div class="span-text" style="font-size: xx-small;margin-right:.3rem">  <span v-if="abstract.columnName === 'TVInfo'">{{abstract.valueText.TLNo}}</span><span v-else>{{abstract.valueText}}</span></div></div>
                    </label>
                  </div>
                </div>
                <div class="item-text" ><div style="height: 1.6rem">
                  <div style="float:left;"><span style="color: #1D66E1;font-size: .7rem" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1">¥{{pro.priceMax}}</span>
                    <span style="color: #1D66E1;font-size: .7rem" v-else>¥{{pro.priceMin}}</span> <span style="margin-left: .3rem"><button class="button workdays" >周期{{pro.cycle}}工作日</button></span></div>
                  <div style="float: right;font-size: .5rem">
                    <span class="sub-span">现货</span>
                    <span class="sub-span">减券</span>
                  </div>
                </div></div>
              </div>
            </label>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
  import $ from 'jquery'
  import emkt from '../../../emkt'
  import {mapState, mapMutations} from 'vuex'
  export default {
    // 在 props 中声明获取父组件的数据通过 message 传过来
    props: ['merchList', 'description', 'showFilterBar', 'showFilterBarForKit', 'isFromSearch', 'proo', 'channel'],
    data () {
      return {
        baseurl: '/emktResources/resocurces/img/merchandise/',
        total: 0
      }
    },
    methods: {
      ...mapMutations([
        'ADD_CART_LIST', 'MERCHDISEGROUP_UPDATE'
      ]),
      addCartListForRecom (pro) {
        this.ADD_CART_LIST(pro)
        $.toast('加入购物车成功！')
      },
      setdatas (pro) {
        if (this.isFromSearch) {
          emkt.customerBehaviours.searchresults.click = {'time': Date.parse(new Date()), 'target': pro.merchandiseId, 'type': emkt.customerBehaviourType.clickMer}
        }
        var _self = this
        _self.MERCHDISEGROUP_UPDATE(pro.compositions)
        this.$router.push({path: '/promotion/Compositions'})
      },
      openshaxuan () {
        $.openPanel('#panel-right-demo')
      },
      getbpromotions (merchdise) {
        if (merchdise.bpromotions) {
          var bpromotions = merchdise.bpromotions
          var r = []
          var t = []
          for (var m = 0; m < bpromotions.length; m++) {
            if (t.indexOf(bpromotions[m].type) === -1) {
              r.push(bpromotions[m])
              t.push(bpromotions[m].type)
              // console.log(m + ' ' + bpromotions[m].type)
            }
          }
          return r
        }
      },
      clickMerchandise (pro) {
        var id = ''
        if (pro.categoryId === 20) {
          id = pro.findId
        } else {
          id = pro.merchandiseId
        }
        if (this.isFromSearch) {
          emkt.customerBehaviours.searchresults.click = {'time': Date.parse(new Date()), 'target': id, 'type': emkt.customerBehaviourType.clickMer}
        }
        if (this.proo) {
          this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}, params: {pro: this.proo}})
        } else if (this.channel) {
          this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}, params: {channel: this.channel}})
        } else {
          this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}})
        }
      }
    },
    computed: {
      ...mapState([
        'queryTotal', 'sessionInfo'
      ]),
      merchs: function () {
        var newmerchList = []
        if (!this.merchList) {
          return newmerchList
        }
        newmerchList = this.merchList
//        for (var i = 0; i < newmerchList.length; i++) {
//          var tags = []
//          var merchandiseMeta = emkt.getEmktMetaData()
//          var tagsmap = merchandiseMeta.tagsMap
//          for (var j = 0; j < newmerchList[i].tagIds.length; j++) {
//            tags.push(tagsmap[newmerchList[i].tagIds[j]].tagLabel)
//          }
//          newmerchList.tags = tags
//          var bpromotions = newmerchList[i].bpromotions
//          var r = []
//          var t = []
//          for (var m = 0; m < bpromotions.length; m++) {
//            if (t.indexOf(bpromotions[m].type) === -1) {
//              r.push(bpromotions[m])
//              t.push(bpromotions[m].type)
//              console.log(m + ' ' + bpromotions[m].type)
//            }
//          }
//          newmerchList[i].bpromotions = r
//        }
        this.total = newmerchList.length
        return newmerchList
      },
      showFilterBarFlag () {
        let flag = true
        let src = this.$route.name
        if (src === 'home') {
          flag = false
        }
        if (!this.showFilterBar) {
          flag = false
        }
        return flag
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



  .checkbox-el {
    display: inline-block;
    text-align: left;
  }


  /*搜索内容区*/
  .item-inner {
    display: block;
  }
  .item-title {
    font-size: 0.6rem;
  }
  item-text {
    margin-top: 0.3rem;
  }
  .sub-span {
    font-size: 0.5rem;
    color: white;
    background-color: #00469A;padding: 0.1rem;border-radius:.25rem;
  }

  .workdays {
    display: inherit;font-size: .5rem;line-height: 0px;height: 0.85rem;border-radius:.45rem;border:1px solid #1D66E1;color:#1D66E1
  }
</style>



// WEBPACK FOOTER //
// NewMerchandiseListC.vue?62198990